var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCloseInputreact = function SvgCloseInputreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 7",
    d: "M7.808 12.258H0v-.512h7.807A7.775 7.775 0 0 0 12 6.977a7.789 7.789 0 0 0 4.192 4.767H24v.513h-7.807A7.8 7.8 0 0 0 12 17.027a7.8 7.8 0 0 0-4.192-4.769Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8990",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
};

export default SvgCloseInputreact;